import {FC} from 'react';
import {Box, Link} from '@chakra-ui/react';
import {ChevronLeftIcon} from '@chakra-ui/icons';
import {observer} from 'mobx-react-lite';
import Latex from 'react-latex-next';

interface IProps {
  name: string;
  onBack: () => void;
}

const BackToFormFC: FC<IProps> = ({name, onBack}) => {
  return (
    <Box p="0 0 4px 0">
      <Link
        color="accent"
        display="flex"
        alignItems="center"
        _hover={{textDecoration: 'none'}}
        onClick={() => onBack()}
      >
        <ChevronLeftIcon boxSize="20px" />
        <Latex>{name}</Latex>
      </Link>
    </Box>
  );
};

export const BackToForm = observer(BackToFormFC);
